<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="isCodeDisabled" v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheMaterialCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="助记码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['quidkCode']" placeholder="请输入助记码"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name', validatorRules.name]" :placeholder="$t('label.pleaseEnterTheNameOfTheMaterial')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.materialCommonName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['buffer1']"  :placeholder="$t('label.pleaseEnterTheCommonNameOfTheMaterial')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.specification')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['spec',validatorRules.spec]" :placeholder="$t('label.pleaseEnterTheSpecification')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.model')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['model']" :placeholder="$t('label.pleaseEnterTheSpecification')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="物料通用名分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['mmGrpCode', validatorRules.mmGrpCode]" dict="efs_md_mm_group,name,code,valid_flag='Y'" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.unitOfMeasurement')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag v-decorator="['mainUnit', validatorRules.mainUnit]" dict="efs_stocking_msur_unit,name,code" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'

  export default {
    name: 'EfsMdMaterialForm',
    components: {
      JFormContainer,
      JDictSelectTag,
      JSearchSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          code: {
            rules: [
              { required: true, message: '请输入物料编码!'},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_material', 'code', value, this.model.id, callback)},
            ]
          },
          name: {
            rules: [
              { required: true, message: '请输入物料名称!'},
              { validator: (rule, value, callback) => validateDuplicateValue('efs_md_material', 'name', value, this.model.id, callback)},
            ]
          },
          spec: {
            rules: [
              { required: true, message: '请选择物料规格!'},
            ]
          },
          mmGrpCode: {
             rules: [
                 { required: true, message: '请选择物料组编码!'},
             ]
          },
          mainUnit: {
              rules: [
                  { required: true, message: '请选择计量单位!'},
              ]
          },
        },
        url: {
          add: "/material/efsMdMaterial/add",
          edit: "/material/efsMdMaterial/edit",
          queryById: "/material/efsMdMaterial/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true
        if(this.model.id){
            this.isCodeDisabled=true
        }else{
            this.isCodeDisabled=false
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','quidkCode','name','spec','model','mmGrpCode','mainUnit','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','quidkCode','name','spec','model','mmGrpCode','mainUnit','validFlag'))
      },
    }
  }
</script>